import { Instagram, Facebook, Linkedin, Share2 } from "lucide-react";
import { useState } from "react";
import { waLink, DEFAULT_WA_MESSAGE, WHATSAPP_DISPLAY, EMAIL } from "../lib/whatsapp";

export const SITE_URL = "https://fk-evenement.fr";

const TikTokIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="h-4 w-4">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
  </svg>
);

const socials = [
  { name: "TikTok", href: "https://www.tiktok.com/@fkevenementiel", icon: <TikTokIcon /> },
  { name: "Instagram", href: "https://www.instagram.com/fkconseil", icon: <Instagram className="h-4 w-4" /> },
  { name: "Facebook", href: "https://www.facebook.com/fkconseil", icon: <Facebook className="h-4 w-4" /> },
  { name: "LinkedIn", href: "https://www.linkedin.com/company/fkconseil", icon: <Linkedin className="h-4 w-4" /> },
];

export const Footer = () => {
  const [copied, setCopied] = useState(false);

  const share = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: "FK Conseil & Événement", text: "L'art du service d'exception — serveurs & maîtres d'hôtel", url: SITE_URL });
        return;
      } catch {}
    }
    await navigator.clipboard.writeText(SITE_URL);
    setCopied(true);
    setTimeout(() => setCopied(false), 2500);
  };

  return (
  <footer data-testid="main-footer" className="border-t border-white/10 bg-[#0a0a0a] px-6 pb-12 pt-24 lg:px-10">
    <div className="mx-auto max-w-7xl">
      <div className="flex flex-wrap items-end justify-between gap-10">
        <div>
          <p className="font-display text-[18vw] leading-none tracking-tight text-white sm:text-8xl lg:text-9xl" data-testid="footer-brand">
            FK<span className="text-gold">.</span>
          </p>
          <p className="mt-4 text-[11px] font-semibold uppercase tracking-[0.4em] text-white/50">
            Conseil &amp; Événement — Service d'exception
          </p>
        </div>
        <div className="text-right">
          <p className="text-[10px] font-semibold uppercase tracking-[0.3em] text-white/40">WhatsApp</p>
          <a
            href={waLink(DEFAULT_WA_MESSAGE)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-phone"
            className="mt-2 block font-display text-3xl text-gold transition-colors duration-300 hover:text-white sm:text-4xl"
          >
            {WHATSAPP_DISPLAY}
          </a>
          <a
            href={`mailto:${EMAIL}`}
            data-testid="footer-email"
            className="mt-3 block text-sm text-white/50 transition-colors duration-300 hover:text-gold"
          >
            {EMAIL}
          </a>
          <button
            type="button"
            onClick={share}
            data-testid="footer-share-button"
            className="mt-4 inline-flex items-center gap-2 rounded-full border border-gold/50 px-5 py-2.5 text-xs font-semibold uppercase tracking-[0.2em] text-gold transition-colors duration-300 hover:bg-gold hover:text-[#0a0a0a]"
          >
            <Share2 className="h-3.5 w-3.5" />
            {copied ? "Lien copié !" : "fk-evenement.fr — Partager"}
          </button>
        </div>
      </div>
      <div className="mt-12 flex items-center gap-4" data-testid="footer-socials">
        <span className="text-[10px] font-semibold uppercase tracking-[0.3em] text-white/40">Suivez-nous</span>
        {socials.map((s) => (
          <a
            key={s.name}
            href={s.href}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`social-${s.name.toLowerCase()}`}
            aria-label={s.name}
            className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 text-white/60 transition-colors duration-300 hover:border-gold hover:text-gold"
          >
            {s.icon}
          </a>
        ))}
      </div>
      <div className="mt-20 flex flex-wrap items-center justify-between gap-4 border-t border-white/10 pt-8 text-xs text-white/30">
        <p data-testid="footer-copyright">© 2026 FK Conseil &amp; Événement. Tous droits réservés.</p>
        <a href="/carte-de-visite" data-testid="footer-card-link" className="transition-colors duration-300 hover:text-gold">
          Carte de visite
        </a>
        <a href="/flyer" data-testid="footer-flyer-link" className="transition-colors duration-300 hover:text-gold">
          Flyer A5
        </a>
        <a href="/modele-devis" data-testid="footer-devis-link" className="transition-colors duration-300 hover:text-gold">
          Modèle de devis
        </a>
        <a href="/facture" data-testid="footer-facture-link" className="transition-colors duration-300 hover:text-gold">
          Factures
        </a>
        <p>Serveurs · Serveuses · Maîtres d'hôtel</p>
      </div>
    </div>
  </footer>
  );
};
